// 数组对象按对象的某一属性排序
export function arrObjSort(attr) {
  return function(object1, object2) {
    var value1 = object1[attr]
    var value2 = object2[attr]

    if (value1 < value2) {
      return -1
    } else if (value1 > value2) {
      return 1
    } else {
      return 0
    }
  }
}
